import { firstLoginWelcome } from './first-login-welcome';
import { featureExplainer } from './feature-explainer';
import { proTipNudge } from './pro-tip-nudge';

// Export all onboard & educate playbooks
export const onboardEducatePlaybooks = [
  firstLoginWelcome,
  featureExplainer,
  proTipNudge,
];

// Export individual playbooks for direct import
export { 
  firstLoginWelcome,
  featureExplainer,
  proTipNudge
};